import React, { FC, FormEvent, MouseEvent } from 'react'
import { Escape } from 'react-bootstrap-icons'
import Button from './Button';

type Props = {
    onClick: (e?: MouseEvent<HTMLButtonElement> | FormEvent<HTMLFormElement>) => void;
    text?: string;
    title?: string;
    disabled?: boolean;
}

const ExistBtn: FC<Props> = ({ onClick, text = '', title = '', disabled = false }) => {

    if (!text) {
        text = 'יציאה';
    }

    return (
        <Button
            text={text}
            title={title || text}
            theme='secondary'
            disabled={disabled}
            onClick={onClick}
            endIcon={<Escape />}
        />
    );
}

export default ExistBtn